import { render } from "./privacy.vue?vue&type=template&id=f7402202&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"

import "./privacy.vue?vue&type=style&index=0&id=f7402202&scoped=true&lang=css"

import exportComponent from "D:\\code\\parking_new\\h5collection\\路边停车\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7402202"]])

export default __exports__